import { useEffect } from "react";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";
import { TrustBand } from "@/components/site/TrustBand";
import { RelatedProducts } from "@/components/site/RelatedProducts";
import { TechGuide, GuideOutro } from "@/components/site/TechGuide";
import { ChooseGuide } from "@/components/site/ChooseGuide";
import { useT, useLang } from "@/i18n";
import { usePageMeta } from "@/lib/pageMeta";

export default function GuidaTecnica() {
  const t = useT();
  const { lang } = useLang();

  const title = `${t("guide.h1", "4 errori fatali")} ${t("guide.h2a", "da evitare nelle")} ${t("guide.h2em", "case in legno.")}`.replace(/\.$/, "");
  const desc = t("guide.meta", "Guida tecnica Emma Industrie: umidità di risalita, progettazione integrata degli impianti, ponti termici e logistica di cantiere. I 4 errori da evitare nella costruzione di case in legno e le soluzioni.");
  usePageMeta({ title, desc, path: "/guida-tecnica", image: "/og-guida-tecnica.jpg", type: "article" });

  useEffect(() => {
    const url = `${window.location.origin}/guida-tecnica`;
    const ld = document.createElement("script");
    ld.type = "application/ld+json";
    ld.text = JSON.stringify({
      "@context": "https://schema.org", "@type": "Article", headline: title, description: desc, inLanguage: lang,
      image: [`${window.location.origin}/og-guida-tecnica.jpg`], mainEntityOfPage: url,
      author: { "@type": "Organization", name: "Emma Industrie srl" },
      publisher: { "@type": "Organization", name: "Emma Industrie srl", logo: { "@type": "ImageObject", url: `${window.location.origin}/img/logo-emma.png` } },
    });
    document.head.appendChild(ld);
    return () => {
      ld.remove();
    };
  }, [title, desc, lang]);

  return (
    <div className="bg-[#EFECE6]" data-testid="guida-tecnica-page">
      <Nav />
      <main>
        <TechGuide />
        <ChooseGuide />
        <GuideOutro />
        <TrustBand />
        <RelatedProducts />
      </main>
      <Footer />
    </div>
  );
}
